import { DetailsCommentOrReportActionTypes, DetailsCommentOrReportState } from './types';
import { Reducer } from 'redux';
import { ActionType } from 'typesafe-actions';
import * as commentOrReportActions from './actions';
import { createCommentOrReport } from './model';
import { ReportStatusTC } from '../../../business/models/typecode.enums';

const initialState: DetailsCommentOrReportState = {
  commentsOrReports: [],
  documentTypeTCValues: []
};

export type CommentOrReportActions = ActionType<typeof commentOrReportActions>;

const reducer: Reducer<DetailsCommentOrReportState, CommentOrReportActions> = (state = initialState, action): DetailsCommentOrReportState => {
  switch (action.type) {
    case DetailsCommentOrReportActionTypes.FETCH_COMMENT_OR_REPORT_SUCCESS: {
      return { ...state, commentsOrReports: [...action.payload] };
    }
    case DetailsCommentOrReportActionTypes.DELETE_COMMENT_OR_REPORT_SUCCESS: {
      const commentsOrReports = state.commentsOrReports.filter((_, index) => index !== action.payload.index);
      
      return { ...state, commentsOrReports: commentsOrReports };
    }
    case DetailsCommentOrReportActionTypes.ADD_COMMENT_OR_REPORT: {
      const commentOrReport = createCommentOrReport();
      return { ...state, commentsOrReports: [...state.commentsOrReports, commentOrReport] };
    }
    case DetailsCommentOrReportActionTypes.FETCH_DOCUMENT_TYPES_SUCCESS: {
      return { ...state, documentTypeTCValues: action.payload };
    }
    case DetailsCommentOrReportActionTypes.UPLOAD_COMMENT_OR_REPORT_SUCCESS: {
      const commentsOrReports = state.commentsOrReports.map((commentOrReport, index) => {
        if (index === action.payload.index) {
          return {
            ...commentOrReport,
            id: action.payload.commentOrReport.id,
            isOnline: true,
            AVScanned: false,
            VirusDetected: false,
          };
        }
        return commentOrReport;
      });
      return { ...state, commentsOrReports };
    }
    case DetailsCommentOrReportActionTypes.UPDATE_REPORT_STATUS_TC: {
      const commentsOrReports = state.commentsOrReports.map((commentOrReport, index) => {
        if (index === action.payload.index) {
          return {
            ...commentOrReport,
            reportStatusTC: action.payload.value,
            ...(action.payload.value === ReportStatusTC.FreeText && {
              url: '',
              amazonKey: '',
              filename: '',
              content: '',
            }),
          };
        }
        return commentOrReport; 
      });
    
      return { ...state, commentsOrReports };
    }    
    case DetailsCommentOrReportActionTypes.UPDATE_DESCRIPTION: {
      const commentsOrReports = state.commentsOrReports.map((commentOrReport, index) => {
        if (index === action.payload.index) {
          return {
            ...commentOrReport,
            description: action.payload.description,
          };
        }
        return commentOrReport;
      });
      return { ...state, commentsOrReports };
    }
    case DetailsCommentOrReportActionTypes.UPDATE_SUBJECT: {
      const commentsOrReports = state.commentsOrReports.map((commentOrReport, index) => {
        if (index === action.payload.index) {
          // Create a new object with the updated subjectLine
          return {
            ...commentOrReport,
            subjectLine: action.payload.subject,
          };
        }
        return commentOrReport; // Return the unchanged objects
      });
    
      return { ...state, commentsOrReports };
    }
    case DetailsCommentOrReportActionTypes.ATTACH_FILE: {
      // Use `map` for immutability
      const commentsOrReports = state.commentsOrReports.map((commentOrReport, index) => {
        if (index === action.payload.index) {
          return {
            ...commentOrReport,
            filename: action.payload.attachment.filename,
            content: action.payload.attachment.content,
            url: action.payload.attachment.url,
          };
        }
        return commentOrReport;
      });
      return {
        ...state,
        commentsOrReports,
      };
    }
    default:
      return state;
  }
};

export { initialState as detailsCommentOrReportInitialState, reducer as detailsCommentOrReportReducer };
